import { showToasts } from '../../helpers/toasts'

import { TOAST_TYPE } from '../../constants/other'
import { keys } from '../../helpers/common'

export function getStepWithError(beErrors, errorFields) {
  let scrollToStep = null

  // cover case when BE returns multiple errors
  errorFields.forEach(errorFieldName => {
    // find field element with error and it's step
    const errorField = document.querySelector(`input[name^=${errorFieldName}]`)
    if (errorField) {
      // step saves to data-step attribute in FormDrawer component
      const stepField = errorField && errorField.closest('div[data-step]')
      let step = stepField && stepField.getAttribute('data-step')
      step = step && parseInt(step)

      if (step !== null && step !== undefined) {
        // skip null/undefined values
        if (scrollToStep === null || step <= scrollToStep) {
          // set the lowest step to push user on the beginning
          scrollToStep = step
        }
      }
    } else {
      // show toasts if error field wasn't found in DOM
      showToasts({
        type: TOAST_TYPE.error,
        message: `${errorFieldName} - ${beErrors[errorFieldName]}`
      })
    }
  })

  return scrollToStep
}

function getTopElementInDom(elements) {
  let topElementInDom = elements[0]
  let topCoordinate = elements[0].getBoundingClientRect().top

  elements.forEach(currElem => {
    const currentElemTopCoordinate = currElem.getBoundingClientRect().top

    if (currentElemTopCoordinate < topCoordinate) {
      topElementInDom = currElem
      topCoordinate = currentElemTopCoordinate
    }
  })

  return topElementInDom
}

function isDomElementInViewPort(elem) {
  const rect = elem.getBoundingClientRect()

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export function handleScrollToFieldWithError(formName, activeStep) {
  // querySelector in is covered with try/catch because it throws an error in some cases e.g.
  // Uncaught DOMException: Failed to execute 'querySelector' on 'Document': 'label[for=carousel_items[0].click_through_link]' is not a valid selector.
  let form
  try {
    form = document.querySelector(`form[data-form-name=${formName}]`)
  } catch (e) {}

  if (!form) {
    return
  }

  const steps = Array.from(form.querySelectorAll('div[data-step]'))
  const currentStep = steps.find(step => Number(step.dataset['step']) === activeStep)

  // errorsContainer gets error messages from the active step in a stepForm or from the entire form if it's not a stepForm.
  const errorsContainer = currentStep || form

  const errorsMessages = Array.from(errorsContainer.querySelectorAll('.error'))

  if (!errorsMessages.length) {
    return
  }

  const topError = getTopElementInDom(errorsMessages)

  if (!isDomElementInViewPort(topError)) {
    // scroll to the top error element, if it's not in the viewport
    const section = topError.closest('section')

    const field = topError.closest('.field')
    const fieldName = field?.querySelector('input')?.getAttribute('name')

    let fieldLabel
    try {
      fieldLabel = document.querySelector(`label[for=${fieldName}]`)
    } catch (e) {}

    const startEndDateRange = topError.closest('.startEndDateRange')

    const radioBlock = topError.closest('.radioBlock')

    const scrollParams = { behavior: 'smooth', block: 'start' }

    if (section) {
      section.scrollIntoView(scrollParams)
    } else if (radioBlock) {
      radioBlock.scrollIntoView(scrollParams)
    } else if (fieldLabel) {
      fieldLabel.scrollIntoView(scrollParams)
    } else if (field) {
      field.scrollIntoView(scrollParams)
    } else if (startEndDateRange) {
      startEndDateRange.scrollIntoView(scrollParams)
    } else {
      topError.scrollIntoView(scrollParams)
    }
  }
}

const extractMessages = (value, fieldPath) => {
  // This handles different types of error messages:
  //   - Simple string messages
  //   - Arrays of messages
  //   - Nested objects with error messages at any depth

  if (typeof value === 'string') {
    return [value]
  }

  if (Array.isArray(value)) {
    return value.flatMap(item => extractMessages(item, fieldPath))
  }

  if (typeof value === 'object' && value !== null) {
    return Object.entries(value).flatMap(([key, val]) => extractMessages(val, `${fieldPath}.${key}`))
  }

  return []
}

export const showToastForNonRenderedFields = (errorsObj, renderedFields) => {
  if (!errorsObj || typeof errorsObj !== 'object' || Array.isArray(errorsObj)) {
    return
  }

  const nonRenderedErrors = []

  keys(errorsObj).forEach(fieldName => {
    if (renderedFields && renderedFields[fieldName] === true) {
      // Field is rendered, skip it
      return
    }

    const messages = extractMessages(errorsObj[fieldName], fieldName)
    if (messages.length) {
      nonRenderedErrors.push({
        field: fieldName,
        messages
      })
    }
  })

  // Show single toast for all non-rendered field errors
  if (nonRenderedErrors.length) {
    const allMessages = nonRenderedErrors.flatMap(({ field, messages }) =>
      messages.map(message => `${field}: ${message}`)
    )

    showToasts({ message: allMessages, type: 'error' })
  }
}
